import * as React from 'react';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import { makeStyles } from '@material-ui/core/styles';
import { Title } from 'react-admin';
import { Block } from '@material-ui/icons';

const useStyles = makeStyles({
  container: {
    textAlign: 'center',
  },
  text: {
    color: '#737373',
    fontFamily: 'sans-serif',
    fontWeight: 'normal',
  },
  image: {
    width: '100px',
    height: '100px',
    display: 'flex',
    margin: 'auto',
  },
});

export default () => {
  const classes = useStyles();
  return (
    <Card>
      <Title title="Not enough rights" />
      <CardContent className={classes.container}>
        <Block className={classes.image} />
        <h3 className={classes.text}>You don&apos;t have permission to this resource.</h3>
      </CardContent>
    </Card>
  );
};
